import request from '@/utils/request'
const common = {
  state: {
    codes: [],
  },
  mutations: {
    SET_CODES(state, data) {
      state.codes = data
      localStorage.setItem('codes', JSON.stringify(data))
    },
  },
  actions: {
    getcodes({ state, commit }) {
      return new Promise((resolve, reject) => {
        if (state.codes.length > 0) {
          return resolve(state.codes)
        }
        if (JSON.parse(localStorage.getItem('codes'))) {
          return resolve(JSON.parse(localStorage.getItem('codes')))
        }
        request({
          url: '/api/common/phone/getCodes',
          method: 'get',
        })
          .then((res) => {
            if (res.code == 0) {
              commit('SET_CODES', res.data)
              resolve(res.data)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
export default common
